import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { CreateCurriculumSection } from '../create-curriculum-section';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { CreateCurriculumSubheader } from '../create-curriculum-subheader';
import FileUploadBox from '../file-upload-box';
import { Field } from '../../auth/field';
import { useFormContext } from 'react-hook-form';

export const CreateCurriculumStep1 = () => {
  const { t } = useTranslations();
  const form = useFormContext();

  return (
    <div className={cn('create-curriculum-step-wrapper flex w-full flex-col gap-4')}>
      <CreateCurriculumSection title={t('Certifikáty')}>
        {/* <div className="flex flex-col gap-4">
          <CreateCurriculumSubheader title={t('text859')} />
          <p className="text-[#63626F]">{t('text1744')}</p>
          <FileUploadBox name="curriculum_file" />
        </div> */}

        <div className="flex flex-col gap-4">
          <CreateCurriculumSubheader title={t('text1745')} />
          <p className="text-[#63626F]">
            {t('Dajte zamestnávateľom vedieť o certifikátoch, ktorých ste vlastníkom.')}
          </p>

          <Field
            name="certificate_description"
            placeholder={t('Certifikáty') + '...'}
            control={form.control}
            type="textarea"
          />
        </div>

        <div className="flex flex-col gap-4">
          <CreateCurriculumSubheader title={t('text1747')} />
          <Field
            name="motivation_letter_description"
            placeholder={t('Motivačný list') + '...'}
            control={form.control}
            type="textarea"
          />
        </div>
      </CreateCurriculumSection>
    </div>
  );
};
